/**
 * How much of the side menu is shown (SYN-3668).
 *
 * Decision, Maria, 29 Oct 2026: while the reissued Command UI is designed (SYN-3661), the
 * current app's menu shows Home, Chat, Apps and Routines only, to members and admins alike.
 * Mine, Global Marketplace, Activity, My Setup and the admin Workspace group are hidden.
 *
 * Only the MENU changes. Every page stays routed, so a link from Home, a chat answer or an
 * email still opens it. To bring the full menu back, set this to "full"; nothing else moves.
 */
export type MenuScope = "simple" | "full";

export const MENU_SCOPE: MenuScope = "simple";
